import { Box } from 'components/Box/Box';

// TODO: Fix this the next time the file is edited.
// oxlint-disable-next-line typescript/no-explicit-any
export function TileBody(props?: Record<string, any>) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <Box p={[20, null, null, 40]} borderRadius="0 0 8px 8px" {...props} />
  );
}
